import { cn as o } from "../../utils/utils.js";
import { jsx as a } from "react/jsx-runtime";
import * as r from "@radix-ui/react-label";
function s({ className: e, ...t }) {
  return /* @__PURE__ */ a(r.Root, {
    "data-slot": "label",
    className: o("flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", e),
    ...t
  });
}
export {
  s as Label
};

//# sourceMappingURL=label.js.map